export default __webpack_public_path__ + "static/media/2348.d1a4985f.png";